module.exports = __webpack_public_path__ + "static/img/17.6277a5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/17.png
// module id = vPsD
// module chunks = 0